import React from 'react';
import { followUpState } from '../lib/followUpStatus';

/**
 * FollowUpBadge — Card P117 PR-A. One badge, four states, used by both the
 * Daily Hit List and the contact list so a rep learns the colours once.
 *
 * ⚠ COLOUR IS NEVER THE ONLY SIGNAL. Each state carries its own words
 * ("Overdue 3 days", "Due today", "Due in 4 days", "Set next action") and a
 * `title`. Red-on-amber is a hard pair to tell apart for a red-green
 * colour-blind reader, and this is a prioritisation control — if it only
 * works for some of the team it does not work.
 *
 * ⚠ "Set next action" is deliberately an instruction rather than "None". The
 * grey state is the one a rep can fix in ten seconds, and the P108 triage
 * found the opposite pattern all over this app: states that describe
 * themselves and ask for nothing.
 */

const STYLES = {
  overdue:   { color: '#991B1B', bg: '#FEE2E2', border: '#FCA5A5' },
  due_today: { color: '#92400E', bg: '#FEF3C7', border: '#FCD34D' },
  upcoming:  { color: '#334155', bg: '#F1F5F9', border: '#CBD5E1' },
  none:      { color: '#64748B', bg: '#F8FAFC', border: '#E2E8F0' },
};

export default function FollowUpBadge({ value, tz, now, compact = false }) {
  const s = followUpState(value, { tz, now });
  const st = STYLES[s.state] || STYLES.none;
  return (
    <span
      data-testid="follow-up-badge"
      data-state={s.state}
      title={s.title}
      style={{
        display: 'inline-block',
        background: st.bg,
        color: st.color,
        border: `1px solid ${st.border}`,
        padding: compact ? '1px 6px' : '2px 8px',
        borderRadius: 10,
        fontSize: compact ? 10 : 11,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        lineHeight: '15px',
      }}
    >
      {s.label}
    </span>
  );
}
